import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import {
  MessagesPanelContentContainer,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/MessagesPanelContentContainer';

const useStyles = buildUseStyles('DesktopMessagesPanel', () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flexGrow: 1,
  },
}));

const DesktopMessagesPanel = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <MessagesPanelContentContainer className={classNames(classes.root, className)} />
  );
};

DesktopMessagesPanel.defaultProps = {
  className: '',
};

DesktopMessagesPanel.propTypes = {
  className: PropTypes.string,
};

export { DesktopMessagesPanel };
